import React, { PureComponent } from 'react';
import { 
	Container, 
	Row, 
	Col, 
	FormGroup, 
	Label, 
	Button, 
	Modal, 
	ModalHeader, 
	ModalBody, 
	ModalFooter, 
	Input,
	Alert
} from 'reactstrap';
import Datetime from "react-datetime";
import Async from 'react-select/async';
import { getUsersRequest } from 'api/user';

export default class MarkAsSentModal extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			modal: false,
			sent_at: null,
			sent_by: null,
			postal_number: null,
			scannedLetterFile: null,
			filtersUser: {}
		}
	}

	toggle = () => this.setState(prevState => ({ modal: !prevState.modal, sent_at: null, sent_by: null, postal_number: null }));

	onChangeSettledDate = (sent_at) => {
		this.setState({
			sent_at
		});
	}

	loadUsers = async (search, callback) => {
		const { filtersUser } = this.state;
		this.setState({
			filtersUser: {
				...filtersUser,
				search,
			},
		});
		if(search) {
			const usersResponse = await getUsersRequest(filtersUser);
			const users = usersResponse.users.map(user => {
				return {
					data: user,
					label: `${user.first_name} ${user.last_name}`,
					value: user._id
				}
			})
			callback(users);
		}
	}
	
	onSelect = (sent_by) => {
		this.setState({
			sent_by
		});

	}

	setPostalNumber = (value) => {
		this.setState({
			postal_number: value
		})
	}

	render() {

		const { sent_at, sent_by, postal_number, scannedLetterFile } = this.state;
		const { onSave, error, loading } = this.props;
		
		return (
			<Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader>Mark Letters as Sent</ModalHeader>
				<ModalBody>
					<Container>
						<Row>
							<Col>
								<FormGroup>
									<Label>Sent At <span className="required-start">*</span></Label>
									<Datetime
										inputProps={{
											className: "form-control",
											placeholder: "Sent At",
											name: "reservation_date"
										}}
										dateFormat="MM/DD/YYYY"
										timeFormat={false}
										value={sent_at}
										onChange={this.onChangeSettledDate}
										closeOnSelect={true}
									/>
								</FormGroup>
								<FormGroup>
									<Label>User <span className="required-start">*</span></Label>
									<Async
										value={sent_by}
										name="selectedClient"
										options={[]}
										loadOptions={this.loadUsers}
										className="basic-multi-select"
										classNamePrefix="select"
										onChange={this.onSelect}
										placeholder="Search client by name or email"
									/>
								</FormGroup>
								<FormGroup>
									<Label>Postal Receipt Number <span className="required-start">*</span></Label>
									<Input
										type="text"
										value={postal_number}
										name="postal_number"
										onChange={(e) => this.setPostalNumber(e.target.value)}
										placeholder="Tracking Number"
									/>
								</FormGroup>
								<FormGroup>
									<Label className='d-block'>Scanned Letter <span className="required-start">*</span></Label>
									<input
										ref={(c) => this.fileUploadRef = c}
										type="file"
										name="scannedLetterFile"
										onChange={(e) => this.setState({ scannedLetterFile: e.target.files[0] })}
										style={{display: 'none'}}
									/>
									<Button
                                            className="btn-round"
                                            color="info"
											onClick={() => this.fileUploadRef.click()}
											style={{fontSize: '14px'}}
                                        >	
                                            Upload{" "}
                                            <i className="tim-icons icon-upload" />
                                        </Button>
									<span>{scannedLetterFile?.name}</span>
								</FormGroup>
							</Col>
						</Row>
						{error &&
							<Row>
								<Col md={12}>
									<Alert color="danger" fade={false}>{error}</Alert>
								</Col>
							</Row>
						}
					</Container>
				</ModalBody>
				<ModalFooter className="justify-content-end">
					<Col className="text-right">
						<Button 
							color="primary" 
							className="btn-success-override mr-2" 
							onClick={() => onSave({ sent_at: sent_at && sent_at.toDate(), sent_by: sent_by && sent_by.value, postal_number, scannedLetterFile })}
							disabled={loading}
						>
							{loading ? "Saving" : "Save"}
						</Button>
						<Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
					</Col>
				</ModalFooter>
			</Modal>
		)
	}
}